import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { AccountType } from '../AccountSummaryPage';
import { useTranslation } from 'react-i18next';
import styles from './AccountTypeBadge.module.scss';

const { MaterialSymbol, withStyles } = vp;

export type AccountBadgeProps = {
  status: AccountType;
};

const cn = withStyles(styles);

const AccountBadge: FunctionComponent<AccountBadgeProps> = ({ status = 'disabled' }: AccountBadgeProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'Accounts.AccountBalances.AccountTypeBadge' });

  return (
    <div className={cn('container', status)}>
      <div>
        {status === 'disabled'
          ? t('accountDisabled', { defaultValue: 'Interest Account Disabled' })
          : status === 'standard'
            ? t('standard', { defaultValue: 'Standard' })
            : t('premium', { defaultValue: 'Standard & Premium' })}
      </div>

      <MaterialSymbol
        fillAmount={status === 'disabled' ? 0 : 1}
        icon={status === 'disabled' ? 'do_not_disturb_on' : 'check_circle'}
        size="12px"
        color={status === 'disabled' ? '#3e3e3e' : status === 'standard' ? '#2F82FF' : '#fbfbfb'}
      />
    </div>
  );
};

export default AccountBadge;
